
import {initWebComponent} from "@/helpers/web-component-helper";
import {DragZoom} from "ol/interaction";
import {
    getGeoLocation,
    removeGeoLocation,
    setGeoLocation,
    setGeoLocationInterval
} from "@/helpers/ol/ol-geolocation-helper";
import {hideAllInfo, hideLayerInfoForm} from "@/helpers/layer/info/layer-info-helper";
import {
    getBySelector,
    hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";

export class OlTrackLocationComponent extends HTMLElement {
    constructor(){
        super();


        const template = document.createElement('template');
        template.innerHTML =
        `
           <div class="btn-group">
            <button type="button" class="btn btn-outline-secondary icon-btn btn-footer btn-lg ml-1 popper-header dropdown-toggle hide-arrow" data-bs-toggle="dropdown" aria-expanded="false">
                <span class="fa fa-location-arrow button-footer-text"></span>
                <div class="popper-tooltip" role="tooltip">
                    Ga naar huidige locatie
                    <div class="arrow" data-popper-arrow=""></div>
                </div>
            </button>
            <div class="dropdown-menu">
             <a href="javascript:void(0)" data-seconds="" class="dropdown-item list-group-item-action">Ga naar huidige locatie</a>
             <p class="dropdown-header">Hoe vaak moet de kaart zich centreren op de huidige locatie:</p>
              <a href="javascript:void(0)" data-seconds="2000" class="dropdown-item list-group-item-action">Elke 2 seconden</a>
              <a href="javascript:void(0)" data-seconds="10000" class="dropdown-item list-group-item-action">Elke 10 seconden</a>
              <a href="javascript:void(0)" data-seconds="30000" class="dropdown-item list-group-item-action">Elke 30 seconden</a>
              <a href="javascript:void(0)" data-seconds="60000"  class="dropdown-item list-group-item-action">Elke 60 seconden</a>
              <div class="dropdown-divider"></div>
             <a href="javascript:void(0)" id="listGroupItemStop" data-seconds="0" class="dropdown-item list-group-item-action text-danger borderless d-none">Stop GPS</a>
            </div>
          </div>
`;
        this.addEventListener('click', (event) => {
            if(event.target.tagName === 'A') {
                removeClassBySelector('.list-group-item-action', 'active')
                hideElementsBySelector('#listGroupItemStop')

                // console.log(event.target.dataset.seconds)

                if(!event.target.dataset.seconds || event.target.dataset.seconds === "0") {
                    setGeoLocationInterval(null)

                    if(event.target.dataset.seconds === "0") {
                        removeGeoLocation()
                        hideElementsBySelector('#listGroupItemStop')
                        getBySelector('ol-track-location').querySelector('button').classList.remove('active')
                    } else {
                        showElementsBySelector('#listGroupItemStop')
                        setGeoLocation(window.map, false, true)
                    }
                } else {
                    showElementsBySelector('#listGroupItemStop')
                    setGeoLocation(window.map)
                    event.target.classList.add('active')
                    setGeoLocationInterval(event.target.dataset.seconds)
                    getBySelector('ol-track-location').querySelector('button').classList.add('active')
                }
            }
        })

        initWebComponent(this, template)
    }
}

